/* ============================================================
   NATTA Form — header (redizajn 10/2026)
   1) mega meni na desktopu
   2) zvjezdica uz rok dostave u traci najave (mali popover)

   Fioka (mobilni meni), korpa i broj u korpi ostaju u natta.js — ovaj
   fajl ih ne dira. Zaseban fajl jer u natta.js paralelno rade drugi
   poslovi; ucitava se sa `defer` iz sections/header.liquid.
   ============================================================ */
(function () {
  'use strict';
  if (window.NattaHeader) return;

  /* ---------- 1) mega meni ----------
     Stavka = link + dugme sa strelicom (aria-expanded). Hover otvara panel
     na uredjajima sa misem; dugme ga otvara sa tastature i na dodir.
     Escape zatvara i vraca fokus na dugme, klik van ga zatvara.

     Zatvaranje na mouseleave ide sa zadrskom: panel je ispod reda
     kategorija, pa mis na putu do panela kratko izadje iz stavke. Bez
     zadrske se panel zatvarao bas dok kupkinja ide prema njemu. */
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 220;

  function canHover() {
    if (!window.matchMedia) return true;
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function initMega(scope) {
    var nav = (scope || document).querySelector('[data-natta-nav]');
    if (!nav || nav.getAttribute('data-mega-ready') === '1') return;
    nav.setAttribute('data-mega-ready', '1');

    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-mega-item]'));
    if (!items.length) return;

    function panelOf(item) { return item.querySelector('[data-mega-panel]'); }
    function toggleOf(item) { return item.querySelector('[data-mega-toggle]'); }

    function close(item) {
      clearTimeout(item._nCloseT);
      clearTimeout(item._nOpenT);
      var panel = panelOf(item);
      var toggle = toggleOf(item);
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
    }

    function open(item, byHover) {
      items.forEach(function (o) { if (o !== item) close(o); });
      clearTimeout(item._nCloseT);
      var panel = panelOf(item);
      var toggle = toggleOf(item);
      if (panel) panel.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (!item.classList.contains('is-open')) item._nOpenedAt = byHover ? Date.now() : 0;
      item.classList.add('is-open');
    }

    function closeAll() { items.forEach(close); }

    items.forEach(function (item) {
      var toggle = toggleOf(item);
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            // Mis je panel upravo otvorio hoverom, a kupkinja odmah klikne
            // strelicu — klik ne smije zatvoriti ono sto je tek otvoreno.
            if (item._nOpenedAt && Date.now() - item._nOpenedAt < 400) return;
            close(item);
          } else {
            open(item, false);
          }
        });
      }
      item.addEventListener('mouseenter', function () {
        if (!canHover()) return;
        clearTimeout(item._nCloseT);
        item._nOpenT = setTimeout(function () { open(item, true); }, OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function () {
        if (!canHover()) return;
        clearTimeout(item._nOpenT);
        item._nCloseT = setTimeout(function () { close(item); }, CLOSE_DELAY);
      });
      // Tab van stavke zatvara panel. relatedTarget je null kad fokus ode
      // na prazno mjesto — to pokriva klik van, ispod.
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !item.contains(e.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      items.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var hadFocus = item.contains(document.activeElement);
        close(item);
        var toggle = toggleOf(item);
        if (hadFocus && toggle) { try { toggle.focus(); } catch (err) {} }
      });
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll();
    });
  }

  /* ---------- 2) zvjezdica uz rok dostave ----------
     Rok 1–3 dana vrijedi samo za komade na stanju; vise od pola kataloga
     je „U dolasku". Zvjezdica otvara kratko objasnjenje. Dva dugmeta
     (puna i kratka verzija trake) dijele isti popover, pa se
     aria-expanded azurira na svim dugmadima koja ga kontrolisu. */
  function starsFor(pop) {
    return document.querySelectorAll('[data-natta-ab-star][aria-controls="' + pop.id + '"]');
  }

  function popOpen(pop, opener) {
    pop.hidden = false;
    pop._nOpener = opener || null;
    Array.prototype.forEach.call(starsFor(pop), function (s) { s.setAttribute('aria-expanded', 'true'); });
    // Fokus u popover da ga citac ekrana procita; Tab zatim vodi na „Zatvori".
    if (!pop.hasAttribute('tabindex')) pop.setAttribute('tabindex', '-1');
    try { pop.focus({ preventScroll: true }); } catch (err) { try { pop.focus(); } catch (err2) {} }
  }

  function popClose(pop, returnFocus) {
    if (pop.hidden) return;
    pop.hidden = true;
    Array.prototype.forEach.call(starsFor(pop), function (s) { s.setAttribute('aria-expanded', 'false'); });
    var back = pop._nOpener;
    pop._nOpener = null;
    if (returnFocus && back) { try { back.focus(); } catch (err) {} }
  }

  function openPops() {
    return document.querySelectorAll('[data-natta-ab-pop]:not([hidden])');
  }

  document.addEventListener('click', function (e) {
    var star = e.target.closest('[data-natta-ab-star]');
    if (star) {
      var pop = document.getElementById(star.getAttribute('aria-controls'));
      if (!pop) return;
      if (pop.hidden) popOpen(pop, star);
      else popClose(pop, false);
      return;
    }
    var closeBtn = e.target.closest('[data-natta-ab-close]');
    if (closeBtn) {
      var own = closeBtn.closest('[data-natta-ab-pop]');
      if (own) popClose(own, true);
      return;
    }
    Array.prototype.forEach.call(openPops(), function (p) {
      if (!p.contains(e.target)) popClose(p, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    Array.prototype.forEach.call(openPops(), function (p) { popClose(p, true); });
  });

  /* ---------- pokretanje ---------- */
  initMega(document);
  // U editoru teme se sekcija ponovo iscrta — novi <nav> treba listenere.
  document.addEventListener('shopify:section:load', function (e) { initMega(e.target); });

  window.NattaHeader = { initMega: initMega };
})();
